import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "time-out-accept-step3" }
const _hoisted_2 = { class: "accept-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = { style: {"text-align":"center"} }
const _hoisted_5 = {
  key: 0,
  class: "info-timeout"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListElement = _resolveComponent("ListElement")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.content.planType), 1),
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.elementsIncluded, (element) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "elements-step3",
            key: element
          }, [
            _createVNode(_component_ListElement, {
              element: element,
              type: "inlcuded"
            }, null, 8, ["element"])
          ]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.elementsNotIncluded, (element) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "elements-step3",
            key: element
          }, [
            _createVNode(_component_ListElement, {
              element: element,
              type: "notInlcuded"
            }, null, 8, ["element"])
          ]))
        }), 128))
      ]),
      (_ctx.content.conditions)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.content.conditions), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        variant: "turquoise",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('desactivateStep3')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Entendido ")
        ]),
        _: 1
      })
    ])
  ]))
}